import React from 'react';
import { FormGroup } from '@components/molecules/form/FormGroup';
import { SmallDocumentList } from '@components/molecules/SmallDocumentList';
import { FileDropZone } from '@components/molecules/FileDropZone';
import { Document } from '@models/document.model';
import { useTranslation } from '@hooks/useTranslation';

interface DocumentObject {
  documentUrl: string | undefined;
  name: string;
  documentId?: string;
  delegateOrganizationId?: string | null;
}

// Helper function to transform DocumentObject to Document
const transformToDocuments = (documents: DocumentObject[]): Document[] => {
  return documents.map(doc => ({
    documentId: doc.documentId,
    name: doc.name,
    url: doc.documentUrl || '',
    category: 'general',
    delegateOrganizationId: doc.delegateOrganizationId || undefined
  }));
};

interface DocumentsTabProps {
  documents: DocumentObject[];
  setDocuments: (documents: DocumentObject[]) => void;
  handleDocumentDelete?: (document: any) => void;
  handleDownload: (pdfUrl: string) => void;
  avatars: File[];
  onFilesChange: (files: File[]) => void;
}

export const DocumentsTab: React.FC<DocumentsTabProps> = ({
  documents,
  handleDocumentDelete,
  avatars,
  onFilesChange,
}) => {
  const tTaskDetail = useTranslation('taskDetail');
  const hasExistingDocuments = documents.length > 0;

  return (
    <>
      {/* Existing Documents */}
      {hasExistingDocuments && (
        <FormGroup label={tTaskDetail.existingDocuments} htmlFor="existing-documents">
          <SmallDocumentList
            documents={transformToDocuments(documents)}
            showDelete={!!handleDocumentDelete}
            onDelete={handleDocumentDelete ? (document) => {
              const originalDoc = documents.find(doc => doc.documentId === document.documentId);
              if (originalDoc) {
                handleDocumentDelete(originalDoc);
              }
            } : undefined}
          />
        </FormGroup>
      )}

      {/* Upload New Documents */}
      <FormGroup
        label={hasExistingDocuments ? tTaskDetail.addNewDocuments : tTaskDetail.documentsLabel}
        htmlFor="documents">
        <FileDropZone
          files={avatars}
          onFilesChange={onFilesChange}
          multiple={true}
          acceptedTypes="all"
          title={tTaskDetail.dropDocumentsHere}
          subtitle={tTaskDetail.documentsSubtitle}
        />
      </FormGroup>
    </>
  );
};
